const choroplethdata = [
    {
        "id": "AFG",
        "value": 601519
    },
    {
        "id": "AGO",
        "value": 107880
    },
    {
        "id": "ALB",
        "value": 199654
    },
    {
        "id": "ARE",
        "value": 366583
    },
    {
        "id": "ARG",
        "value": 479050
    },
    {
        "id": "ARM",
        "value": 977967
    },
    {
        "id": "ATA",
        "value": 9931
    },
    {
        "id": "ATF",
        "value": 560784
    },
    {
        "id": "AUT",
        "value": 962617
    },
    {
        "id": "AZE",
        "value": 856658
    },
    {
        "id": "BDI",
        "value": 817974
    },
    {
        "id": "BEL",
        "value": 648696
    },
    {
        "id": "BEN",
        "value": 500038
    },
    {
        "id": "BFA",
        "value": 257013
    },
    {
        "id": "BGD",
        "value": 860863
    },
    {
        "id": "BGR",
        "value": 999290
    },
    {
        "id": "BHS",
        "value": 964151
    },
    {
        "id": "BIH",
        "value": 267240
    },
    {
        "id": "BLR",
        "value": 409882
    },
    {
        "id": "BLZ",
        "value": 596507
    },
    {
        "id": "BOL",
        "value": 714287
    },
    {
        "id": "BRN",
        "value": 701177
    },
    {
        "id": "BTN",
        "value": 470194
    },
    {
        "id": "BWA",
        "value": 911343
    },
    {
        "id": "CAF",
        "value": 695983
    },
    {
        "id": "CAN",
        "value": 330917
    },
    {
        "id": "CHE",
        "value": 958342
    },
    {
        "id": "CHL",
        "value": 51583
    },
    {
        "id": "CHN",
        "value": 63950
    },
    {
        "id": "CIV",
        "value": 16918
    },
    {
        "id": "CMR",
        "value": 191993
    },
    {
        "id": "COG",
        "value": 137728
    },
    {
        "id": "COL",
        "value": 250751
    },
    {
        "id": "CRI",
        "value": 496264
    },
    {
        "id": "CUB",
        "value": 314663
    },
    {
        "id": "-99",
        "value": 683449
    },
    {
        "id": "CYP",
        "value": 281233
    },
    {
        "id": "CZE",
        "value": 792543
    },
    {
        "id": "DEU",
        "value": 155781
    },
    {
        "id": "DJI",
        "value": 511095
    },
    {
        "id": "DNK",
        "value": 625353
    },
    {
        "id": "DOM",
        "value": 48259
    },
    {
        "id": "DZA",
        "value": 588456
    },
    {
        "id": "ECU",
        "value": 93500
    },
    {
        "id": "EGY",
        "value": 255452
    },
    {
        "id": "ERI",
        "value": 108702
    },
    {
        "id": "ESP",
        "value": 411734
    },
    {
        "id": "EST",
        "value": 635124
    },
    {
        "id": "ETH",
        "value": 545624
    },
    {
        "id": "FIN",
        "value": 625783
    },
    {
        "id": "FJI",
        "value": 201820
    },
    {
        "id": "FLK",
        "value": 812436
    },
    {
        "id": "FRA",
        "value": 910896
    },
    {
        "id": "GAB",
        "value": 180128
    },
    {
        "id": "GBR",
        "value": 724091
    },
    {
        "id": "GEO",
        "value": 998529
    },
    {
        "id": "GHA",
        "value": 835226
    },
    {
        "id": "GIN",
        "value": 535742
    },
    {
        "id": "GMB",
        "value": 538315
    },
    {
        "id": "GNB",
        "value": 800335
    },
    {
        "id": "GNQ",
        "value": 134561
    },
    {
        "id": "GRC",
        "value": 215738
    },
    {
        "id": "GTM",
        "value": 243227
    },
    {
        "id": "GUY",
        "value": 902020
    },
    {
        "id": "HND",
        "value": 532460
    },
    {
        "id": "HRV",
        "value": 129580
    },
    {
        "id": "HTI",
        "value": 784953
    },
    {
        "id": "HUN",
        "value": 750054
    },
    {
        "id": "IDN",
        "value": 789331
    },
    {
        "id": "IND",
        "value": 488370
    },
    {
        "id": "IRL",
        "value": 740520
    },
    {
        "id": "IRN",
        "value": 634667
    },
    {
        "id": "IRQ",
        "value": 461222
    },
    {
        "id": "ISL",
        "value": 266573
    },
    {
        "id": "ISR",
        "value": 352696
    },
    {
        "id": "ITA",
        "value": 478806
    },
    {
        "id": "JAM",
        "value": 504834
    },
    {
        "id": "JOR",
        "value": 740283
    },
    {
        "id": "JPN",
        "value": 655662
    },
    {
        "id": "KAZ",
        "value": 262487
    },
    {
        "id": "KEN",
        "value": 75569
    },
    {
        "id": "KGZ",
        "value": 959253
    },
    {
        "id": "KHM",
        "value": 735141
    },
    {
        "id": "OSA",
        "value": 186410
    },
    {
        "id": "KWT",
        "value": 47595
    },
    {
        "id": "LAO",
        "value": 101711
    },
    {
        "id": "LBN",
        "value": 917761
    },
    {
        "id": "LBR",
        "value": 759509
    },
    {
        "id": "LBY",
        "value": 179416
    },
    {
        "id": "LKA",
        "value": 367152
    },
    {
        "id": "LSO",
        "value": 235842
    },
    {
        "id": "LTU",
        "value": 724292
    },
    {
        "id": "LUX",
        "value": 197675
    },
    {
        "id": "LVA",
        "value": 58818
    },
    {
        "id": "MAR",
        "value": 472883
    },
    {
        "id": "MDA",
        "value": 652716
    },
    {
        "id": "MDG",
        "value": 732975
    },
    {
        "id": "MEX",
        "value": 333179
    },
    {
        "id": "MKD",
        "value": 585707
    },
    {
        "id": "MLI",
        "value": 923495
    },
    {
        "id": "MMR",
        "value": 296575
    },
    {
        "id": "MNE",
        "value": 871706
    },
    {
        "id": "MNG",
        "value": 404097
    },
    {
        "id": "MOZ",
        "value": 995962
    },
    {
        "id": "MRT",
        "value": 63800
    },
    {
        "id": "MWI",
        "value": 572171
    },
    {
        "id": "MYS",
        "value": 595267
    },
    {
        "id": "NAM",
        "value": 134165
    },
    {
        "id": "NCL",
        "value": 524624
    },
    {
        "id": "NER",
        "value": 359300
    },
    {
        "id": "NGA",
        "value": 790725
    },
    {
        "id": "NIC",
        "value": 69749
    },
    {
        "id": "NLD",
        "value": 26724
    },
    {
        "id": "NOR",
        "value": 724682
    },
    {
        "id": "NPL",
        "value": 25618
    },
    {
        "id": "NZL",
        "value": 385561
    },
    {
        "id": "OMN",
        "value": 977146
    },
    {
        "id": "PAK",
        "value": 93917
    },
    {
        "id": "PAN",
        "value": 285953
    },
    {
        "id": "PER",
        "value": 419895
    },
    {
        "id": "PHL",
        "value": 429599
    },
    {
        "id": "PNG",
        "value": 826024
    },
    {
        "id": "POL",
        "value": 8390
    },
    {
        "id": "PRI",
        "value": 944126
    },
    {
        "id": "PRT",
        "value": 456742
    },
    {
        "id": "PRY",
        "value": 131030
    },
    {
        "id": "QAT",
        "value": 387345
    },
    {
        "id": "ROU",
        "value": 749774
    },
    {
        "id": "RUS",
        "value": 835974
    },
    {
        "id": "RWA",
        "value": 718631
    },
    {
        "id": "ESH",
        "value": 19369
    },
    {
        "id": "SAU",
        "value": 16702
    },
    {
        "id": "SDN",
        "value": 316615
    },
    {
        "id": "SDS",
        "value": 143970
    },
    {
        "id": "SEN",
        "value": 800701
    },
    {
        "id": "SLB",
        "value": 961085
    },
    {
        "id": "SLE",
        "value": 325366
    },
    {
        "id": "SLV",
        "value": 611126
    },
    {
        "id": "ABV",
        "value": 144346
    },
    {
        "id": "SOM",
        "value": 561277
    },
    {
        "id": "SRB",
        "value": 197370
    },
    {
        "id": "SUR",
        "value": 945475
    },
    {
        "id": "SVK",
        "value": 764354
    },
    {
        "id": "SVN",
        "value": 955797
    },
    {
        "id": "SWZ",
        "value": 326247
    },
    {
        "id": "SYR",
        "value": 293923
    },
    {
        "id": "TCD",
        "value": 3893
    },
    {
        "id": "TGO",
        "value": 868355
    },
    {
        "id": "THA",
        "value": 183738
    },
    {
        "id": "TJK",
        "value": 906464
    },
    {
        "id": "TKM",
        "value": 622906
    },
    {
        "id": "TLS",
        "value": 559436
    },
    {
        "id": "TTO",
        "value": 998124
    },
    {
        "id": "TUN",
        "value": 422184
    },
    {
        "id": "TUR",
        "value": 332873
    },
    {
        "id": "TWN",
        "value": 637813
    },
    {
        "id": "TZA",
        "value": 668149
    },
    {
        "id": "UGA",
        "value": 941552
    },
    {
        "id": "UKR",
        "value": 685534
    },
    {
        "id": "URY",
        "value": 802553
    },
    {
        "id": "USA",
        "value": 822729
    },
    {
        "id": "UZB",
        "value": 646552
    },
    {
        "id": "VEN",
        "value": 117747
    },
    {
        "id": "VNM",
        "value": 167379
    },
    {
        "id": "VUT",
        "value": 19566
    },
    {
        "id": "PSE",
        "value": 359643
    },
    {
        "id": "YEM",
        "value": 248844
    },
    {
        "id": "ZAF",
        "value": 768130
    },
    {
        "id": "ZMB",
        "value": 61853
    },
    {
        "id": "ZWE",
        "value": 985820
    },
    {
        "id": "KOR",
        "value": 416942
    }
]
export default choroplethdata;